import { render, staticRenderFns } from "./NextTenFrameSVG.vue?vue&type=template&id=258ef749"
import script from "./NextTenFrameSVG.vue?vue&type=script&lang=js"
export * from "./NextTenFrameSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports